import keyMirror from 'keymirror';

export default keyMirror({
  REQUEST_USER: null,
  REQUEST_USER_SUCCESS: null,
  REQUEST_USER_ERROR: null,

  REQUEST_REPO: null,
  REQUEST_REPO_SUCCESS: null,
  REQUEST_REPO_ERROR: null,

  REQUEST_STARRED_REPOS_PAGE: null,
  REQUEST_STARRED_REPOS_PAGE_SUCCESS: null,
  REQUEST_STARRED_REPOS_PAGE_ERROR: null,

  REQUEST_STARGAZER_PAGE: null,
  REQUEST_STARGAZER_PAGE_SUCCESS: null,
  REQUEST_STARGAZER_PAGE_ERROR: null
});



/** WEBPACK FOOTER **
 ** ./scripts/constants/ActionTypes.js
 **/